var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.quickActionIcon,{tag:"component",attrs:{"size":20}})
}
var staticRenderFns = []

export { render, staticRenderFns }